<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" 
    closable mask-closable :okText="getTranslation('c006')" :cancelText="getTranslation('b182')" :title="title">
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('u041') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col span="20">
      <Input v-model="user.name" maxlength="15" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m013') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col span="20">
      <Input v-model="user.sort" type="number" />
      </Col>
    </Row> 
    <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Input, Icon, Button } from 'view-design';
import { mapGetters } from 'vuex'
import { checkSeqCorrect, postJsError } from '@/util/util.js'
export default {
  name: 'UserRole', // 组件名称
  components: {
    Modal, Row, Col, Input, Icon, Button
  },
  props: {
    propVisible: Boolean,
    editId: Number
  },
  data() {
    return {
      user: {},
      title: '',
      modalLoading: true,
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },

    StateMap() {
      return {
        0: this.getTranslation("u010"),
        1: this.getTranslation("u011"),
        2: this.getTranslation("u012"),
        3: this.getTranslation("m004")
      };
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.editId > 0) {
          this.title = this.getTranslation('u042');
          this.getOneUser(this.editId)
        } else {
          this.title = this.getTranslation('u030');
          this.user = {}
        }
      }
    }
  },

  created() {

  },
  methods: {
    getOneUser(id) {
      let url = API_URL["roleGetOne"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data;
            this.user.state = this.user.state.toString();
            this.user.password = this.originPassword;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      let _this = this;
      this.modalLoading = true;
      if (!this.validateForm()) {
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      let url = API_URL["roleAdd"];

      let params = Object.assign({}, this.user);
      if (this.editId > 0) {
        url = API_URL["roleUpdate"];
        if (params.password == this.originPassword) {
          params.password = "";
        }
      }

      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            if (this.editId > 0) {
              this.$Message.success(this.getTranslation('u037'));
            } else {
              this.$Message.success(this.getTranslation('u038'));
            }
            this.visible = false
            _this.$emit("refresh-page")

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      this.user.sort = Number(this.user.sort);
      if (!this.user.name || this.user.name.length < 2) {
        errorMsg = this.getTranslation('p010');
        isValid = false;
      } else if (!checkSeqCorrect(this.user.sort)) {
        errorMsg = this.getTranslation('p011');
        isValid = false;
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css'); 
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
}

.field-line {
  margin-bottom: 8px;
}
</style>